import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useParams } from "react-router-dom";
import PaginationCustom from "../../components/Pagination";
import Stats from "../../components/Stats";
import { tripViolations } from "../../store/Slices/TripSlice";
import "../../styles/Trip.css";
import { formatDate, formatString } from "../../utils/helper";
import SpinnerLoader from "../../utils/SpinnerLoader";
import { highIcon, lowIcon, mediumIcon } from "../../utils/svgs";

const severityClass = {
  high: "sev_high",
  medium: "sev_medium",
  low: "sev_low",
};

const severityIcon = {
  high: highIcon,
  medium: mediumIcon,
  low: lowIcon,
};

const TripViolations = () => {
  const dispatch = useDispatch();
  const { id } = useParams();

  const [currentPage, setCurrentPage] = useState(1);
  const [limit, setLimit] = useState(10);

  const { tripViolationsData, tripViolationsLoading } = useSelector((state) => state.trips);

  useEffect(() => {
    const data = {
      trip_id: id,
    }
    const params = {
      page: currentPage,
      limit: limit,
    }

    dispatch(tripViolations({ data, params }));
  }, [currentPage, limit])

  const violationStats = [
    { title: "Total Violations", value: tripViolationsData?.total_violations || 0, text: "", icon: null },
    {
      title: "Open",
      value: tripViolationsData?.total_violations_open || 0,
      text: "",
      icon: null,
      className: "warning_stat",
    },
    {
      title: "High Priority",
      value: tripViolationsData?.high_priority_violations || 0,
      text: "",
      icon: null,
      className: "late",
    },
    {
      title: "Resolved",
      value: tripViolationsData?.resolve_violations || 0,
      text: "",
      icon: null,
      className: "completed",
    },
  ];

  if (tripViolationsLoading) {
    return <SpinnerLoader />;
  }

  return (
    <div className="violations_wrap">
      <Stats statsData={violationStats} />

      <div className="violations_table_card">
        <div className="violations_table_header">
          <div>
            <h6>Trip Violations</h6>
            <p>Main information for this trip record.</p>
          </div>
        </div>

        <div className="violations_table">
          <div className="violations_head">
            <span>Sr. No.</span>
            <span>Timestamp</span>
            <span>Location</span>
            <span>Type</span>
            <span>Severity</span>
          </div>
          {tripViolationsData?.results?.map((row, index) => (
            <div className="violations_row" key={row.sr}>
              <span>{(currentPage - 1) * limit + index + 1}</span>
              <span>{formatDate(row.occurred_at)}</span>
              <span>{row.location}</span>
              <span>
                <strong>{formatString(row.type)}</strong>
                <br />
                <small>{row.description}</small>
              </span>
              <span className={`severity_item ${severityClass[row.priority]}`}>
                <span className="sev_icon">{severityIcon[row.priority]}</span>
                <span>{row.priority}</span>
              </span>
            </div>
          ))}

          <PaginationCustom
            className="violation_pagination"
            totalItems={tripViolationsData?.meta?.totalItems}
            totalPages={tripViolationsData?.meta?.totalPages}
            currentPage={currentPage}
            setCurrentPage={setCurrentPage}
            limit={limit}
            setLimit={setLimit}
          />
        </div>
      </div>
    </div>
  );
};

export default TripViolations;
